import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./CookieConsent.css";

const STORAGE_KEY = "pms_cookie_consent_v1";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const accept = (choice) => {
    try {
      localStorage.setItem(STORAGE_KEY, choice);
    } catch (_) {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent" role="dialog" aria-label="Choix cookies">
      <div className="cookie-consent__inner">
        <p>
          ProMeetService utilise des cookies <strong>nécessaires</strong> au fonctionnement (connexion,
          sécurité). Les cookies de mesure ne sont activés qu&apos;avec votre accord.{" "}
          <Link to="/legal/terms#cookies">En savoir plus</Link>
        </p>
        <div className="cookie-consent__actions">
          <button type="button" className="cookie-consent__btn" onClick={() => accept("essential")}>
            Essentiels uniquement
          </button>
          <button
            type="button"
            className="cookie-consent__btn cookie-consent__btn--primary"
            onClick={() => accept("all")}
          >
            Tout accepter
          </button>
        </div>
      </div>
    </div>
  );
}
